import _ from 'lodash';
import { useMemo } from 'react';

import { TableProps } from '../features/DataTable/Table/Table';

function useTableDataToDisplay(
  data: Array<object>,
  sortField: TableProps['sortField'],
  sortOrder: TableProps['sortOrder'],
  customDataModifier: TableProps['customDataModifier']
) {
  const dataToDisplay = useMemo<any[]>(() => {
    if (!data) {
      return [];
    }

    // Prevent any mutation from affecting the source data
    let returnVal = _.clone(data);

    if (typeof customDataModifier === 'function') {
      returnVal = customDataModifier(returnVal);
    }

    if (!sortField || !sortOrder) {
      return returnVal;
    }

    return _.clone(returnVal).sort((a: any, b: any) =>
      a[sortField] > b[sortField]
        ? sortOrder
        : b[sortField] > a[sortField]
        ? sortOrder * -1
        : 0
    );
  }, [customDataModifier, data, sortField, sortOrder]);

  return dataToDisplay;
}

export default useTableDataToDisplay;
